import jQuery from 'jquery';
import LazyLoad from 'vanilla-lazyload';
import LazyEmbed from 'lazyembed2';
import objectFitVideos from 'object-fit-videos';
import Isotope from 'isotope-layout';
import PageLoadedQueue from "../../../../../../Avency.Avency.Shared/Resources/Private/Assets/JavaScript/Project/PageLoadedQueue";

window.jQuery = window.$ = jQuery;
window.LazyLoad = LazyLoad;
window.LazyEmbed = LazyEmbed;
window.objectFitVideos = objectFitVideos;
window.Isotope = Isotope;
window.PageLoadedQueue = PageLoadedQueue;
